module.exports = __webpack_public_path__ + "media/wrong.083a1e34.mp3";